import { render, staticRenderFns } from "./SocialRecordPayment.vue?vue&type=template&id=016ee9af&"
import script from "./SocialRecordPayment.vue?vue&type=script&lang=js&"
export * from "./SocialRecordPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports